'use strict';

import FieldView from 'views/record/Field';

class CheckBoxField extends FieldView {
    /**
     * Initialize the checkbox based on the field properties.
     *
     * @param {type} options
     * @returns {undefined}
     */
    constructor (options) {
        super(options);

        this.checked = this.fieldState.getValue() === '1';

        if(this.fieldState.isReadOnly()) {
            this.fieldState.setEnabled(false);
        }
        this.dominantColor = options.dominantColor;
    }

    render() {
        super.render();
        if(!this.fieldState.isReadOnly()) {
            this.$el.find('.checkbox').on('click', this.handleClick.bind(this));
        }
        if(this.dominantColor) {
            this.$el.find('.cr-icon').css('color', this.dominantColor);
        }
    }

    handleClick(evt) {
        if($(evt.target).hasClass('note-download')) { return; }
        this.$el.find('input').attr('checked', this.$el.find('input').attr('checked') ? false : true);
        this.performChange(false, this.$el,false);
    }

    getFieldValue() {
        return this.$el.find('.changeableField').is(':checked');
    }

    parseValue (value){
        super.parseValue();
        if(value === '1' || value === 'true' || value === 'on' || value === true){
            return '1';
        }else{
            return '0';
        }
    }

    setModelValue(value) {
        super.setModelValue(value);
        this.checked = this.fieldState.getValue() === '1';
        this.getFieldElement().prop('checked', this.checked);
    }

    getlabelElement(){
        return this.$el.find('.checkbox');
    }

    getFieldElement(){
        return this.$el.find('.checkbox');
    }

    getFieldPositionModifier(loc, left){
        return {
            width: loc.fieldWidth,
            height: loc.fieldHeight,
            'margin-left': left === '0px'? 10 : 0,
            'margin-top' : ( loc.height - loc.fieldHeight ) / 2
        };
    }

    setDominantColor(color) {
        this.dominantColor = color;
        this.$el.find('.cr-icon').css('color', this.dominantColor);
    }

    isLabelClickable() {
        return false;
    }
}

export default CheckBoxField;
